/** Every spelling the two sheets use, plus the obvious neighbours. */
const COUNTRY_BY_NAME = new Map([
    ['us', 'US'],
    ['usa', 'US'],
    ['united states', 'US'],
    ['uk', 'GB'],
    ['united kingdom', 'GB'],
    ['england', 'GB'],
    ['germany', 'DE'],
    ['deutschland', 'DE'],
    ['france', 'FR'],
    ['netherlands', 'NL'],
    ['nl', 'NL'],
    ['spain', 'ES'],
    ['sweden', 'SE'],
    ['denmark', 'DK'],
    ['switzerland', 'CH'],
    ['finland', 'FI'],
    ['czechia', 'CZ'],
    ['czech republic', 'CZ'],
    ['belgium', 'BE'],
    ['canada', 'CA'],
    ['austria', 'AT'],
    ['uae', 'AE'],
    ['united arab emirates', 'AE'],
    ['poland', 'PL'],
    ['italy', 'IT'],
    ['israel', 'IL'],
    ['ireland', 'IE'],
    ['japan', 'JP'],
    ['luxembourg', 'LU'],
    ['singapore', 'SG'],
    ['estonia', 'EE'],
    ['australia', 'AU'],
    ['norway', 'NO'],
    ['portugal', 'PT'],
    ['greece', 'GR'],
    ['turkey', 'TR'],
    ['india', 'IN'],
    ['china', 'CN'],
    ['hong kong', 'HK'],
    ['brazil', 'BR'],
    ['lithuania', 'LT'],
    ['latvia', 'LV'],
    ['romania', 'RO'],
    ['hungary', 'HU'],
    ['slovakia', 'SK'],
    ['slovenia', 'SI'],
    ['bulgaria', 'BG'],
    ['croatia', 'HR'],
    ['iceland', 'IS'],
    ['ukraine', 'UA'],
    ['south korea', 'KR'],
    ['korea', 'KR'],
    ['mexico', 'MX'],
    ['nigeria', 'NG'],
    ['south africa', 'ZA'],
    ['saudi arabia', 'SA'],
    ['qatar', 'QA'],
    ['kenya', 'KE'],
    ['new zealand', 'NZ'],
    ['cyprus', 'CY'],
    ['malta', 'MT'],
    ['monaco', 'MC'],
    ['liechtenstein', 'LI'],
]);
/** "US / UK" is two offices; "Eastern Europe" is not a country. */
export function parseHq(raw) {
    const countries = [];
    const unmapped = [];
    for (const part of (raw ?? '').split(/[/,&]|\band\b/)) {
        const token = part.trim();
        if (token === '')
            continue;
        const code = COUNTRY_BY_NAME.get(token.toLowerCase());
        if (code === undefined) {
            unmapped.push(token);
        }
        else if (!countries.includes(code)) {
            countries.push(code);
        }
    }
    return { countries, unmapped };
}
//# sourceMappingURL=hq.js.map